webpackJsonp([43],{

/***/ 210:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_build_component__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_closest__ = __webpack_require__(74);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }






/* harmony default export */ __webpack_exports__["default"] = (function (nameSpace, selector) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__utils_build_component__["default"])({
    nameSpace: nameSpace,
    selector: selector,
    initState: {
      isSlider: false,
      videos: false,
      activeVideo: null
    },
    initFunction: function initFunction($el, params) {
      var $slides = $el.querySelectorAll('.' + nameSpace + '__slide');
      var $videos = $el.querySelectorAll('.' + nameSpace + '__video-bg');
      var slider = void 0;

      //
      // Methods
      //

      function onLoadedImageSetClasses(isLoaded, $image) {
        if (isLoaded) {
          new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 74)).then(function (module) {
            var $slide = module.default({
              el: $image,
              selector: '.' + nameSpace + '__slide'
            });
            $slide.classList.add(nameSpace + '__slide--image-is-loaded');
            var $imageBg = module.default({
              el: $image,
              selector: '.' + nameSpace + '__image-bg'
            });
            var src = window.innerWidth > window.innerHeight ? $image.src : $image.dataset.srcMobile;
            $imageBg.style.backgroundImage = 'url(\'' + src + '\')';
          });
        }
      }

      function setImagesSrc($list) {
        [].concat(_toConsumableArray($list)).forEach(function ($image) {
          __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 181)).then(function (module) {
            setTimeout(function () {
              if ($image.src && $image.naturalWidth && $image.naturalHeight) {
                onLoadedImageSetClasses(true, $image);
              } else {
                var instance = void 0;
                if ($image.Component && $image.Component['bloc-img-load']) {
                  instance = $image.Component['bloc-img-load'];
                } else {
                  instance = module.default(nameSpace + '__image').init({ $el: $image });
                }
                instance.addObserver(function (state) {
                  return onLoadedImageSetClasses(state.isLoaded, $image);
                });
                instance.setSrc();
              }
            }, 0);
          });
        });
      }

      function initVideo($list) {
        [].concat(_toConsumableArray($list)).forEach(function ($videoBg, index) {
          var $video = $videoBg.querySelector('video');
          var $slide = Object(__WEBPACK_IMPORTED_MODULE_2__utils_closest__["default"])({ el: $videoBg, selector: '.' + nameSpace + '__slide' });
          $slide.classList.add(nameSpace + '__slide--is-video');
          if (typeof $videoBg.VideoJs === 'undefined') {
            __webpack_require__.e/* import() */(4/* duplicate */).then(__webpack_require__.bind(null, 195)).then(function (module) {
              module.default({
                el: $video,
                container: $videoBg
              });
              __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 191)).then(function (module) {
                $videoBg.VideoJs = module.default($video, {
                  controls: false,
                  loop: true,
                  autoplay: false,
                  muted: true,
                  loadingSpinner: false,
                  preload: 'auto'
                });
                if (!params.getState().isSlider) {
                  params.setState({ activeVideo: index });
                }
              });
            });
          }
        });
      }

      function onSliderInit() {
        setImagesSrc($el.querySelectorAll('img[data-block-img-load]'));
        if (params.getState().videos) {
          var $duplacatedVideos = $el.querySelectorAll('.swiper-slide-duplicate .' + nameSpace + '__video-bg');
          params.setState(function (prevState) {
            return { videos: [].concat(_toConsumableArray(prevState.videos), _toConsumableArray($duplacatedVideos)) };
          });
        }
      }

      function onSlideChange() {
        if (params.getState().videos) {
          var $currentActiveVideo = $el.querySelector('.swiper-slide-active .' + nameSpace + '__video-bg');
          params.setState({ activeVideo: $currentActiveVideo ? params.getState().videos.indexOf($currentActiveVideo) : null });
        }
      }

      function initSlider() {
        __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 510)).then(function (module) {
          var Swiper = module.default;
          slider = new Swiper($el.querySelector('.swiper-container'), {
            autoplay: true,
            loop: true,
            on: {
              init: onSliderInit,
              slideChangeTransitionEnd: onSlideChange
            }
          });
        });
      }

      function playActiveVideo(index, prevIndex) {
        __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 191)).then(function (module) {
          if (index !== null) {
            params.getState().videos[index].VideoJs.play();
          }
          if (prevIndex !== null) {
            params.getState().videos[prevIndex].VideoJs.pause();
          }
        });
      }

      //
      // Life Cycle
      //

      params.onStateUpdate(function (newState, prevState) {
        if (!prevState.isSlider && newState.isSlider) {
          initSlider();
        }
        if (!__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(prevState.videos, newState.videos)) {
          initVideo(newState.videos);
        }
        if (newState.videos && prevState.activeVideo !== newState.activeVideo) {
          playActiveVideo(newState.activeVideo, prevState.activeVideo);
        }
      });

      //
      // Procedures
      //

      if ($videos.length && window.innerWidth > window.innerHeight) {
        params.setState({ videos: [].concat(_toConsumableArray($videos)) });
      }

      if ($slides.length > 1) {
        params.setState({ isSlider: true });
      } else {
        setImagesSrc($el.querySelectorAll('img[data-block-img-load]'));
      }

      //
      // Listeners / Observers
      //

      //
      // Public API
      //

      return {};
    }
  });
});

/***/ })

});


// WEBPACK FOOTER //
// js/chunk-hero-slider.bundle.js